export default [
  {
    name: 'Brand',
    subsections: [
      {
        name: 'Brand promise',
        url: '/#brand-promise',
      },
      {
        name: 'Brand values',
        url: '/#brand-values',
      },
      {
        name: 'Brand personality',
        url: '/#brand-personality',
      },
      {
        name: 'Design principles',
        url: '/#design-principles',
      },
      {
        name: 'Brand anthem',
        url: '/#brand-video',
      },
    ],
  },
  {
    name: 'Visuals',
    subsections: [
      {
        name: 'Logos',
        url: '/visuals-logo',
      },
      {
        name: 'Typography',
        url: '/visuals-typography',
      },
      {
        name: 'Color',
        url: '/visuals-color',
      },
      {
        name: 'Diversity, equity + inclusion',
        url: '/visuals-dei',
      },
      {
        name: 'Illustration',
        url: '/visuals-illustration',
      },
      {
        name: 'Iconography',
        url: '/visuals-iconography',
      },
      {
        name: 'Photography',
        url: '/visuals-photography',
      },
      {
        name: 'Motion',
        url: '/visuals-motion',
      },
    ],
  },
  {
    name: 'Voice',
    subsections: [
      {
        name: 'Intro',
        url: '/voice-intro',
      },
      {
        name: 'Voice + tone',
        url: '/voice-tone',
      },
      {
        name: 'Bumpers + rules',
        url: '/voice-bumpers-rules',
      },
      {
        name: 'Diversity, equity + inclusion',
        url: '/voice-dei',
      },
      {
        name: 'Ads',
        url: '/voice-ads',
      },
      {
        name: 'Email',
        url: '/voice-emails',
      },
      {
        name: 'Social media',
        url: '/voice-social-media',
      },
      {
        name: 'UX/UI',
        url: '/voice-ux-ui',
      },
      {
        name: 'Content',
        url: '/voice-content',
      },
      {
        name: 'Legal + compliance',
        url: '/voice-legal',
      },
      {
        name: 'Style + grammar',
        url: '/voice-style-grammar',
      },
      {
        name: 'TLDR',
        url: '/voice-tldr',
      },
    ],
  },
  {
    name: 'Audience',
    subsections: [
      {
        name: 'Intro',
        url: '/audience-intro',
      },
      {
        name: 'Thrivers',
        url: '/audience-thrivers',
      },
      {
        name: 'Balancers',
        url: '/audience-balancers',
      },
      {
        name: 'Cautious',
        url: '/audience-cautious',
      },
    ],
  },
  {
    name: 'Currency',
    url: 'https://nerdwallet.style',
  },
  {
    name: 'Resources',
    url: 'https://nerdwallet.atlassian.net/wiki/spaces/centralcreative/overview',
  },
];
